import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';

import Header from '../header';
import Footer from '../footer';

import { Home_Component } from '../home';
import { Rating_Component } from '../rating';
import { Profile_Component } from '../profile';
import { Orgs_Component } from '../orgs';
import { Org_Component } from '../org';
import { Specialist_Component } from '../specialist';
import { Advertisements_Component } from '../jobs';
import { Advertisement_Component } from '../job';
import { About_Component } from '../about';
import { Terms_Component } from '../terms';
import { Help_Component } from '../help';
import { Memos_Component } from '../memos';
import { Memo_Component } from '../memo';
import { About_health_Component } from '../about_health';
import { About_health_item_Component } from '../about_health_item';
import { Search_doctor_Component } from '../search_doctor';

import { City_1321_01_Component } from '../search_doctor/city/1321_01';
import { City_1321_02_Component } from '../search_doctor/city/1321_02';
import { City_1321_03_Component } from '../search_doctor/city/1321_03';
import { City_1321_04_Component } from '../search_doctor/city/1321_04';
import { City_1321_05_Component } from '../search_doctor/city/1321_05';
import { City_1321_06_Component } from '../search_doctor/city/1321_06';
import { City_1321_07_Component } from '../search_doctor/city/1321_07';
import { City_1321_08_Component } from '../search_doctor/city/1321_08';
import { City_1321_09_Component } from '../search_doctor/city/1321_09';
import { City_1321_10_Component } from '../search_doctor/city/1321_10';
import { City_1321_11_Component } from '../search_doctor/city/1321_11';
import { City_1321_12_Component } from '../search_doctor/city/1321_12';
import { City_1321_13_Component } from '../search_doctor/city/1321_13';
import { City_1321_14_Component } from '../search_doctor/city/1321_14';
import { City_1321_15_Component } from '../search_doctor/city/1321_15';
import { City_1321_16_Component } from '../search_doctor/city/1321_16';
import { City_1321_17_Component } from '../search_doctor/city/1321_17';
import { City_1321_18_Component } from '../search_doctor/city/1321_18';
import { City_1321_19_Component } from '../search_doctor/city/1321_19';
import { City_1321_20_Component } from '../search_doctor/city/1321_20';

import { City_1307_01_Component } from '../search_doctor/city/1307_01';
import { City_1307_02_Component } from '../search_doctor/city/1307_02';
import { City_1307_03_Component } from '../search_doctor/city/1307_03';
import { City_1307_04_Component } from '../search_doctor/city/1307_04';
import { City_1307_05_Component } from '../search_doctor/city/1307_05';
import { City_1307_06_Component } from '../search_doctor/city/1307_06';
import { City_1307_07_Component } from '../search_doctor/city/1307_07';
import { City_1307_08_Component } from '../search_doctor/city/1307_08';
import { City_1307_09_Component } from '../search_doctor/city/1307_09';
import { City_1307_10_Component } from '../search_doctor/city/1307_10';
import { City_1307_11_Component } from '../search_doctor/city/1307_11';
import { City_1307_12_Component } from '../search_doctor/city/1307_12';
import { City_1307_13_Component } from '../search_doctor/city/1307_13';
import { City_1307_14_Component } from '../search_doctor/city/1307_14';
import { City_1307_15_Component } from '../search_doctor/city/1307_15';
import { City_1307_16_Component } from '../search_doctor/city/1307_16';
import { City_1307_17_Component } from '../search_doctor/city/1307_17';
import { City_1307_18_Component } from '../search_doctor/city/1307_18';
import { City_1307_19_Component } from '../search_doctor/city/1307_19';
import { City_1307_20_Component } from '../search_doctor/city/1307_20';

import { City_1274_01_Component } from '../search_doctor/city/1274_01';
import { City_1274_02_Component } from '../search_doctor/city/1274_02';
import { City_1274_03_Component } from '../search_doctor/city/1274_03';
import { City_1274_04_Component } from '../search_doctor/city/1274_04';
import { City_1274_05_Component } from '../search_doctor/city/1274_05';
import { City_1274_06_Component } from '../search_doctor/city/1274_06';
import { City_1274_07_Component } from '../search_doctor/city/1274_07';
import { City_1274_08_Component } from '../search_doctor/city/1274_08';
import { City_1274_09_Component } from '../search_doctor/city/1274_09';
import { City_1274_10_Component } from '../search_doctor/city/1274_10';
import { City_1274_11_Component } from '../search_doctor/city/1274_11';
import { City_1274_12_Component } from '../search_doctor/city/1274_12';
import { City_1274_13_Component } from '../search_doctor/city/1274_13';
import { City_1274_14_Component } from '../search_doctor/city/1274_14';
import { City_1274_15_Component } from '../search_doctor/city/1274_15';
import { City_1274_16_Component } from '../search_doctor/city/1274_16';
import { City_1274_17_Component } from '../search_doctor/city/1274_17';
import { City_1274_18_Component } from '../search_doctor/city/1274_18';
import { City_1274_19_Component } from '../search_doctor/city/1274_19';
import { City_1274_20_Component } from '../search_doctor/city/1274_20';

import { News_Component } from '../news';
import { New_Component } from '../new';
import { News_mz_Component } from '../news_mz';
import { New_mz_Component } from '../new_mz';
import { Articles_Component } from '../articles';
import { Article_Component } from '../article';
import { Useful_information_Component } from '../useful_information';
import { Useful_information_item_Component } from '../useful_information_item';
import { Surveys_Component } from '../surveys';
import { Survey_Component } from '../survey';
import { Specializations_Component } from '../specializations';
import { Specialization_Component } from '../specialization';
import { Symptoms_Component } from '../symptoms';
import { Symptom_Component } from '../symptom';
import { Food_products_Component } from '../food_products';
import { Food_product_Component } from '../food_product';
import { Calculators_Component } from '../calculators';
import { Calculators_1_Component } from '../calculators_list/1';
import { Calculators_2_Component } from '../calculators_list/2';
import { Checkup_health_Component } from '../checkup_health';
import { Hls_Component } from '../hls';
import { Hls_1_Component } from '../hls/list/1';
import { Hls_2_Component } from '../hls/list/2';
import { Hls_3_Component } from '../hls/list/3';
import { Hls_4_Component } from '../hls/list/4';
import { Hls_5_Component } from '../hls/list/5';
import { Hls_6_Component } from '../hls/list/6';
import { Hls_7_Component } from '../hls/list/7';
import { Hls_8_Component } from '../hls/list/8';
import { Hls_9_Component } from '../hls/list/9';
import { Hls_10_Component } from '../hls/list/10';
import { Hls_11_Component } from '../hls/list/11';
import { Hls_Surveys_Component } from '../hls/surveys';
import { SpecialistInfo_Component } from '../specialist-info';

import { Error404_Component } from "../errors/404";
import { ConfigProvider } from 'antd';

/*
            /%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%#,           
      &%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%     
   (%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%.  
  %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% 
 %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&@@@@@&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%                       &%%%%%%%%%%%%%%%%%%%%%%%%%%%
%%%%%%%%%%%%%%%%%%%%%%%&                                .&%%%%%%%%%%%%%%%%%%%%%%
%%%%%%%%%%%%%%%%%%%%%                                       &%%%%%%%%%%%%%%%%%%%
%%%%%%%%%%%%%%%%%%                                             %%%%%%%%%%%%%%%%%
%%%%%%%%%%%%%%%%                   %%%%%%%%%%%                   %%%%%%%%%%%%%%%
%%%%%%%%%%%%%%,                    %%%%%%%%%%%                    &%%%%%%%%%%%%%
%%%%%%%%%%%%%                      %%%%%%%%%%%                     .%%%%%%%%%%%%
%%%%%%%%%%%%                       %%%%%%%%%%%                       %%%%%%%%%%%
%%%%%%%%%%%                        %%%%%%%%%%%                       (%%%%%%%%%%
%%%%%%%%%%&          %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%          %%%%%%%%%%
%%%%%%%%%%,          %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%          @%%%%%%%%%
%%%%%%%%%%           %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%          &%%%%%%%%%
%%%%%%%%%%*          %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%          @%%%%%%%%%
%%%%%%%%%%&          %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%          %%%%%%%%%%
%%%%%%%%%%%.                       %%%%%%%%%%%                       #%%%%%%%%%%
%%%%%%%%%%%%                       %%%%%%%%%%%                      .%%%%%%%%%%%
%%%%%%%%%%%%%                      %%%%%%%%%%%                     *%%%%%%%%%%%%
%%%%%%%%%%%%%%#                    %%%%%%%%%%%                    &%%%%%%%%%%%%%
%%%%%%%%%%%%%%%%                   %%%%%%%%%%%                  *%%%%%%%%%%%%%%%
%%%%%%%%%%%%%%%%%%.                                           /%%%%%%%%%%%%%%%%%
%%%%%%%%%%%%%%%%%%%%&                                       &%%%%%%%%%%%%%%%%%%%
%%%%%%%%%%%%%%%%%%%%%%%%*                               #%%%%%%%%%%%%%%%%%%%%%%%
(%%%%%%%%%%%%%%%%%%%%%%%%%%%&,                     (&%%%%%%%%%%%%%%%%%%%%%%%%%%%
 %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&
  %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%& 
   ,%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%   
      %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%,     
*/

export class App extends React.Component {
    constructor() {
        super();
    }

    render() {
        return (
            <ConfigProvider theme={{ hashed: false }}>
                <Header />
                <div className='ui-app'>
                    <Switch>
                        <Route exact path='/' component={ Home_Component } />
                        <Route exact path='/profile' component={ Profile_Component } />
                        <Route exact path='/rating' component={ Rating_Component } />
                        <Route exact path='/org' component={ Orgs_Component } />
                        <Route exact path='/org/:orgID' component={ Org_Component } />
                        <Route exact path='/specialist/:specialistID' component={ Specialist_Component } />
                        <Route exact path='/job' component={ Advertisements_Component } />
                        <Route exact path='/job/:jobID' component={ Advertisement_Component } />
                        <Route exact path='/about' component={ About_Component } />
                        <Route exact path='/terms' component={ Terms_Component } />
                        <Route exact path='/help' component={ Help_Component } />
                        <Route exact path='/memos' component={ Memos_Component } />
                        <Route exact path='/memos/:postID' component={ Memo_Component } />
                        <Route exact path='/about_health' component={ About_health_Component } />
                        <Route exact path='/about_health/:postID' component={ About_health_item_Component } />
                        <Route exact path='/search_doctor' component={ Search_doctor_Component } />

                        <Route exact path='/search_doctor/1321/1' component={ City_1321_01_Component } />
                        <Route exact path='/search_doctor/1321/2' component={ City_1321_02_Component } />
                        <Route exact path='/search_doctor/1321/3' component={ City_1321_03_Component } />
                        <Route exact path='/search_doctor/1321/4' component={ City_1321_04_Component } />
                        <Route exact path='/search_doctor/1321/5' component={ City_1321_05_Component } />
                        <Route exact path='/search_doctor/1321/6' component={ City_1321_06_Component } />
                        <Route exact path='/search_doctor/1321/7' component={ City_1321_07_Component } />
                        <Route exact path='/search_doctor/1321/8' component={ City_1321_08_Component } />
                        <Route exact path='/search_doctor/1321/9' component={ City_1321_09_Component } />
                        <Route exact path='/search_doctor/1321/10' component={ City_1321_10_Component } />
                        <Route exact path='/search_doctor/1321/11' component={ City_1321_11_Component } />
                        <Route exact path='/search_doctor/1321/12' component={ City_1321_12_Component } />
                        <Route exact path='/search_doctor/1321/13' component={ City_1321_13_Component } />
                        <Route exact path='/search_doctor/1321/14' component={ City_1321_14_Component } />
                        <Route exact path='/search_doctor/1321/15' component={ City_1321_15_Component } />
                        <Route exact path='/search_doctor/1321/16' component={ City_1321_16_Component } />
                        <Route exact path='/search_doctor/1321/17' component={ City_1321_17_Component } />
                        <Route exact path='/search_doctor/1321/18' component={ City_1321_18_Component } />
                        <Route exact path='/search_doctor/1321/19' component={ City_1321_19_Component } />
                        <Route exact path='/search_doctor/1321/20' component={ City_1321_20_Component } />

                        <Route exact path='/search_doctor/1307/1' component={ City_1307_01_Component } />
                        <Route exact path='/search_doctor/1307/2' component={ City_1307_02_Component } />
                        <Route exact path='/search_doctor/1307/3' component={ City_1307_03_Component } />
                        <Route exact path='/search_doctor/1307/4' component={ City_1307_04_Component } />
                        <Route exact path='/search_doctor/1307/5' component={ City_1307_05_Component } />
                        <Route exact path='/search_doctor/1307/6' component={ City_1307_06_Component } />
                        <Route exact path='/search_doctor/1307/7' component={ City_1307_07_Component } />
                        <Route exact path='/search_doctor/1307/8' component={ City_1307_08_Component } />
                        <Route exact path='/search_doctor/1307/9' component={ City_1307_09_Component } />
                        <Route exact path='/search_doctor/1307/10' component={ City_1307_10_Component } />
                        <Route exact path='/search_doctor/1307/11' component={ City_1307_11_Component } />
                        <Route exact path='/search_doctor/1307/12' component={ City_1307_12_Component } />
                        <Route exact path='/search_doctor/1307/13' component={ City_1307_13_Component } />
                        <Route exact path='/search_doctor/1307/14' component={ City_1307_14_Component } />
                        <Route exact path='/search_doctor/1307/15' component={ City_1307_15_Component } />
                        <Route exact path='/search_doctor/1307/16' component={ City_1307_16_Component } />
                        <Route exact path='/search_doctor/1307/17' component={ City_1307_17_Component } />
                        <Route exact path='/search_doctor/1307/18' component={ City_1307_18_Component } />
                        <Route exact path='/search_doctor/1307/19' component={ City_1307_19_Component } />
                        <Route exact path='/search_doctor/1307/20' component={ City_1307_20_Component } />

                        <Route exact path='/search_doctor/1274/1' component={ City_1274_01_Component } />
                        <Route exact path='/search_doctor/1274/2' component={ City_1274_02_Component } />
                        <Route exact path='/search_doctor/1274/3' component={ City_1274_03_Component } />
                        <Route exact path='/search_doctor/1274/4' component={ City_1274_04_Component } />
                        <Route exact path='/search_doctor/1274/5' component={ City_1274_05_Component } />
                        <Route exact path='/search_doctor/1274/6' component={ City_1274_06_Component } />
                        <Route exact path='/search_doctor/1274/7' component={ City_1274_07_Component } />
                        <Route exact path='/search_doctor/1274/8' component={ City_1274_08_Component } />
                        <Route exact path='/search_doctor/1274/9' component={ City_1274_09_Component } />
                        <Route exact path='/search_doctor/1274/10' component={ City_1274_10_Component } />
                        <Route exact path='/search_doctor/1274/11' component={ City_1274_11_Component } />
                        <Route exact path='/search_doctor/1274/12' component={ City_1274_12_Component } />
                        <Route exact path='/search_doctor/1274/13' component={ City_1274_13_Component } />
                        <Route exact path='/search_doctor/1274/14' component={ City_1274_14_Component } />
                        <Route exact path='/search_doctor/1274/15' component={ City_1274_15_Component } />
                        <Route exact path='/search_doctor/1274/16' component={ City_1274_16_Component } />
                        <Route exact path='/search_doctor/1274/17' component={ City_1274_17_Component } />
                        <Route exact path='/search_doctor/1274/18' component={ City_1274_18_Component } />
                        <Route exact path='/search_doctor/1274/19' component={ City_1274_19_Component } />
                        <Route exact path='/search_doctor/1274/20' component={ City_1274_20_Component } />

                        <Route exact path='/news' component={ News_Component } />
                        <Route exact path='/news/:postID' component={ New_Component } />
                        <Route exact path='/news_mz' component={ News_mz_Component } />
                        <Route exact path='/news_mz/:postID' component={ New_mz_Component } />
                        <Route exact path='/articles' component={ Articles_Component } />
                        <Route exact path='/articles/:postID' component={ Article_Component } />
                        <Route exact path='/useful_information' component={ Useful_information_Component } />
                        <Route exact path='/useful_information/:postID' component={ Useful_information_item_Component } />
                        <Route exact path='/surveys' component={ Surveys_Component } />
                        <Route exact path='/surveys/:surveysID' component={ Survey_Component } />
                        <Route exact path='/specializations' component={ Specializations_Component } />
                        <Route exact path='/specializations/:specializationID' component={ Specialization_Component } />
                        <Route exact path='/symptoms' component={ Symptoms_Component } />
                        <Route exact path='/symptoms/:symptomID' component={ Symptom_Component } />
                        <Route exact path='/food_products' component={ Food_products_Component } />
                        <Route exact path='/food_products/:food_productID' component={ Food_product_Component } />
                        <Route exact path='/calculators' component={ Calculators_Component } />
                        <Route exact path='/calculators/1' component={ Calculators_1_Component } />
                        <Route exact path='/calculators/2' component={ Calculators_2_Component } />
                        <Route exact path='/checkup_health' component={ Checkup_health_Component } /> 
                        <Route exact path='/hls' component={ Hls_Component } />
                        <Route exact path='/hls/1' component={ Hls_1_Component } />
                        <Route exact path='/hls/2' component={ Hls_2_Component } />
                        <Route exact path='/hls/3' component={ Hls_3_Component } />
                        <Route exact path='/hls/4' component={ Hls_4_Component } />
                        <Route exact path='/hls/5' component={ Hls_5_Component } />
                        <Route exact path='/hls/6' component={ Hls_6_Component } />
                        <Route exact path='/hls/7' component={ Hls_7_Component } />
                        <Route exact path='/hls/8' component={ Hls_8_Component } />
                        <Route exact path='/hls/9' component={ Hls_9_Component } />
                        <Route exact path='/hls/10' component={ Hls_10_Component } />
                        <Route exact path='/hls/11' component={ Hls_11_Component } />
                        <Route exact path='/hls/surveys' component={ Hls_Surveys_Component } />
                        <Route exact path='/specialist-info' component={ SpecialistInfo_Component } />
                        <Route exact path='*' component={ Error404_Component } />
                    </Switch>
                </div>
                <Footer />
            </ConfigProvider>
        );
    }
}